import * as messageService from "../../services/message.service";
import * as faqService from '../../services/faq.service';


const state = {
    faqAll:[],
    faqAllActive:[],
};

const getters = {
    gettFaqAll:state => (state.faqAll),
    gettFaqAllActive:state => (state.faqAllActive),
};

const actions = {
    async fetchFaqAll({ commit } ){
        try {
            const response = await faqService.all();
            commit('setFaqAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchFaqAllActive({ commit } ){
        try {
            const response = await faqService.allActive();
            commit('setFaqAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setFaqAll:(state, res) => (
        state.faqAll =  res
    ),
    setFaqAllActive:(state, res) => (
        state.faqAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}